import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

/** The findings of one engagement — a long-lived branch or a pull request. */
export const engagementRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/engagements/:engagementId',
});

/**
 * One asset: its long-lived branches, open pull requests and exceptions, as
 * tabs of the same page.
 */
export const assetRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/assets/:assetId',
});

/** The asset page's Exceptions tab: its triaged findings, across engagements. */
export const assetExceptionsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/assets/:assetId/exceptions',
});
